import { render, staticRenderFns } from "./top_menu.vue?vue&type=template&id=6be408c4&scoped=true&"
import script from "./top_menu.vue?vue&type=script&lang=js&"
export * from "./top_menu.vue?vue&type=script&lang=js&"
import style0 from "./top_menu.vue?vue&type=style&index=0&id=6be408c4&scoped=true&lang=scss&"
import style1 from "./top_menu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be408c4",
  null
  
)

export default component.exports